import React from 'react';
import styles from './UIGamePlayerInformationAvatar.module.scss';
import { VictoryPointStateReader } from '@colonist/game-base-types';
import { Avatar } from '../../../../common/Avatar/index.ts';
import { VictoryPointCountBanner } from '../../../../common/VictoryPointCountBanner/VictoryPointCountBanner.tsx';
import { UIGamePlayerOptionsDropdown } from '../../../../common/UIGamePlayerOptionsDropdown/index.ts';
import clsx from 'clsx';
/**
 * @deprecated Use usePlayerVictoryPoints instead
 */ const getVictoryPointsText = (playerState, isCurrentUser)=>{
    const publicVictoryPoints = VictoryPointStateReader.totalPublicVictoryPoints(playerState.victoryPointsState);
    const privateVictoryPoints = VictoryPointStateReader.totalPrivateVictoryPoints(playerState.victoryPointsState);
    const doesPlayerHaveHiddenVictoryPoints = publicVictoryPoints !== privateVictoryPoints && privateVictoryPoints !== 0 && isCurrentUser;
    return {
        key: 'strings:game.playerInformation.victoryPoint.display',
        options: {
            publicVictoryPoints: publicVictoryPoints,
            privateVictoryPoints: privateVictoryPoints,
            context: doesPlayerHaveHiddenVictoryPoints ? 'private' : ''
        }
    };
};
export const UIGamePlayerInformationAvatar = ({ victoryPointsToWin, playerValidator, isCurrentUser, className })=>{
    const victoryPointsText = getVictoryPointsText(playerValidator.state, isCurrentUser);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.avatarAndPoints, className, {
            [styles.currentUser]: isCurrentUser
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerOptionsDropdown, {
        className: styles.avatarWrapper,
        playerValidator: playerValidator
    }, /*#__PURE__*/ React.createElement(Avatar, {
        className: styles.avatar,
        color: playerValidator.color,
        image: playerValidator.displayIcon,
        profilePictureUrl: playerValidator.profilePictureUrl
    })), /*#__PURE__*/ React.createElement(VictoryPointCountBanner, {
        className: styles.victoryPointsContainer,
        victoryPointsText: victoryPointsText,
        victoryPointsToWin: victoryPointsToWin,
        isLargeRibbon: isCurrentUser
    }));
};
